import { render } from "./ChooseTime.vue?vue&type=template&id=ff66d794"
import script from "./ChooseTime.vue?vue&type=script&lang=js"
export * from "./ChooseTime.vue?vue&type=script&lang=js"

import exportComponent from "/builds/nordhealth/projects/therapy/easypractice/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__